import { handleRequestATT } from './RequestATT'
import { RequestLocation } from './RequestLocation'
import { RequestPushNotifications } from './RequestPushNotifications copy'

export const requestPermission = (type: string) => {
  switch (type.toLowerCase()) {
    case 'notifications':
      RequestPushNotifications()
      break
    case 'att':
      handleRequestATT()
      break
    case 'location':
      RequestLocation()
      break
  }
}
